
const chartColors = [
    "#5b9bd5",
    "#ed7d31",
    "#a5a5a5",
    "#ffbf00",
    "#4473c4",
    "#70ad47",
    "#255e91",
    "#9e480e",
    "#636363",
    "#997300"
  ]
  
  export const getColor = (idx) => {
    var index = (idx == undefined || idx > 9) ? Math.floor(Math.random() * 10) : idx;
    return chartColors[index > 9 ? 9 : index];
  }
  
  
  
  const colors = {
    GOLD:'#ffd700',
    BLACK: "#000",
    WHITE: "#FFF",
    DODGER_BLUE: "#4658ba",
    SECONDARY_BLUE: "#66D7FA",
    SILVER: "#BEBEBE",
    TORCH_RED: "#F8262F",
    MISCHKA: "#E5E4E6",
    GREEN: '#83BF7C',
    LIGHT_GRAY: '#E5E5E5',
    GRAY:'#d3d3d3',
    DARK_GRAY:'#91938f',
    PURPLE:'#B0B7DE',
    LIGHT_PURPLE:'#EDEFF9',
    BACKGROUND_COLOR: '#fcfdfe',
    PRIMARY_TEXT_COLOR:'#565353',
    RED: '#ff0000'
  };
  
  export default colors;